const KEY = 'areCookiesAccepted'

const setAcceptCookies = areAccepted => {
  try {
    localStorage.setItem(KEY, areAccepted)
    return true
  } catch (err) {
    console.warn('Error saving config', err)
    return false
  }
}

const getAreCookiesAccepted = () => {
  try {
    const areCookiesAccepted = localStorage.getItem(KEY)
    return areCookiesAccepted
  } catch (err) {
    console.warn('Error loading config', err)
    return false
  }
}

export { setAcceptCookies, getAreCookiesAccepted }
